// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nec_title.fig_title.active{visibility:visible}.v-image__image.v-image__image--cover{background-size:100%}", ""]);
// Exports
module.exports = exports;
